import Image from "next/image";

type IndustryFeaturesProps = {
    featuresTitle: string;
    features: {
        title: string;
        description: string | JSX.Element;
        image: { src: string; alt: string };
    }[];
};
  
export function IndustryFeatures({ featuresTitle,features }: IndustryFeaturesProps) {
    return (
        <div className="section_industry-features bg-[var(--gray--10)] dark:bg-[var(--gray--100)]">
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-vertical padding-xhuge">
                        <div className="product-features_component">
                            <div className="max-width-large align-center">
                                <div className="text-align-center">
                                    <h2 className="text-[var(--primary--burgundy)] dark:text-[var(--primary--pink)]" dangerouslySetInnerHTML={{ __html: featuresTitle }}/>
                                    <div className="padding-bottom padding-xlarge"></div>
                                </div>
                            </div>
                            <div className="product-features_list-wrapper">
                                <div role="list" className="product-features_list">
                                    {features.map((feature, idx) => (
                                        <div role="listitem" className="product-features_list-item" key={idx}>
                                            <div className="product-features_layout">
                                                <div className="product-features_content-wrapper">
                                                    <h2 className="heading-medium text-dark dark:text-white">{feature.title}</h2>
                                                    <div className="padding-bottom padding-xsmall"></div>
                                                    <div className="text-rich-text w-richtext text-gray-800 dark:text-gray-300">
                                                        <p>{feature.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product-features_layout">
                                                <div className="product-features_image-wrapper has-shadow">
                                                    <Image
                                                        src={feature.image.src}
                                                        unoptimized
                                                        width={500}
                                                        height={480}
                                                        alt={feature.image.alt}
                                                        className="product-features_image is-rounded"
                                                        style={{ width: "100%", height: "auto" }}
                                                    />
                                                    <div className="product-features_image-shadow"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* <CtaButtonsComponent ctas={ctas}/> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
